type FeedDomain = {
  domain_id: string;
  joblist_page?: {
    joblist_page_id: string;
    job_ad_pages: ({ job_ad_page_id: string } | null | undefined)[];
  } | null;
};

/** The domains a page is on: a job list page's one domain, or every domain whose job list has the job ad page. */
export const pageDomains = <D extends FeedDomain>(
  domains: D[] | undefined,
  isJobAd: boolean,
  pageId: string | undefined
): D[] =>
  (domains ?? []).filter((domain) =>
    isJobAd
      ? domain.joblist_page?.job_ad_pages.some((page) => page?.job_ad_page_id === pageId)
      : domain.joblist_page?.joblist_page_id === pageId
  );

export const feedSource = (apiUrl: string | undefined, tenantId: string | undefined, domains: FeedDomain[]): string =>
  `${apiUrl}/feed/${tenantId}?domain_id=${domains.map((domain) => domain.domain_id).join(",")}`;
